import type { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "../hooks/useAuth";

function Loading() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-steel/40 border-t-brandorange" />
    </div>
  );
}

// Every redirect here is "~"-absolute: these guards render inside nested
// routes (/app, /admin), where a bare "/admin" would resolve relative to the
// nest — e.g. /app/admin, which RequireTenant redirects again, forever: the
// infamous blank screen after ending impersonation.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <Loading />;
  if (status === "anonymous") return <Redirect to="~/signin" />;
  return <>{children}</>;
}

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <Loading />;
  if (status !== "super_admin") return <Redirect to="~/" />;
  return <>{children}</>;
}

export function RequireTenant({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <Loading />;
  if (status === "anonymous") return <Redirect to="~/signin" />;
  if (status === "unprovisioned") return <Redirect to="~/welcome" />;
  if (status === "super_admin") return <Redirect to="~/admin" />;
  return <>{children}</>;
}
